enum PhotoSource {
  ALL = 'all',
  CAMERA = 'camera',
  ENVIRONMENT = 'environment',
  USER = 'user',
}

export default PhotoSource;
